import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ICategoryFilter } from 'src/app/shared/models/category/ICategoryFilter';
import { ICategory } from 'src/app/shared/models/category/ICategory';
import { Observable } from 'rxjs';
import { TreeNodeItem } from 'src/app/shared/models/tree/TreeNodeItem';
import { ApiFilterInterface } from 'src/app/shared/models/api-filter-in-request/ApiFilterInterface';
import { EnvironmentResolveService } from '../environment-resolve/environment-resolve.service';

@Injectable({
  providedIn: 'root'
})
export class CategoriesService {
  constructor(private http: HttpClient, private erService: EnvironmentResolveService) {}

  public getCategories(application: string, categoriesFilter?: ICategoryFilter): Observable<{ results: ICategory[] }> {
    const filter: ApiFilterInterface[] = [{ field: 'active', operator: 'equals', value: '1' }];
    if (categoriesFilter) {
      if (categoriesFilter.parentId) {
        filter.push({ field: 'parent', operator: 'equals', value: categoriesFilter.parentId });
      }
      if (categoriesFilter.level) {
        filter.push({ field: 'level', operator: 'equals', value: categoriesFilter.level });
      }
      if (categoriesFilter.useCase) {
        filter.push({ field: 'use_case', operator: 'in', value: categoriesFilter.useCase });
      }
    }
    return this.http.post<{ results: ICategory[] }>(this.erService.environmentERS.apiUrl, {
      application,
      method: 'searchCategorys',
      parameters: {
        filter,
        paging: {
          sort: 'order',
          dir: 'ASC'
        }
      }
    });
  }

  public getCategory(application: string, id: string): Observable<ICategory> {
    return this.http.post<ICategory>(this.erService.environmentERS.apiUrl, {
      application,
      method: 'getCategory',
      parameters: { id }
    });
  }

  public getItem(application: string, id: string): Observable<TreeNodeItem> {
    return this.http.post<TreeNodeItem>(this.erService.environmentERS.apiUrl, {
      application,
      method: 'getItem',
      parameters: { id }
    });
  }

  public setRating(id: string, rating: string): void {
    this.http
      .post<TreeNodeItem>(this.erService.environmentERS.apiUrl, {
        application: 'Knowledge',
        method: 'rateItem',
        parameters: { id, rating }
      })
      .subscribe();
  }
}
